<template>
  <div>
    <listado-acuerdos-clientes-tabla
      :data="data"
      :getListaAcuerdosClientes="getListaAcuerdosClientes"
      :load="load"
      :dataInicial="dataInicial"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getAcuerdosClientes } from "@/constants/lineas";

import ListadoAcuerdosClientesTabla from "../../../components/tablas/lineas/ListadoAcuerdosClientesTabla";

export default {
  components: { ListadoAcuerdosClientesTabla },
  data() {
    return {
      data: [],
      load: false,
      dataInicial: [],
    };
  },
  computed: {
    ...mapState("lineas", [
      "dataDatatableTarifasAcuerdosClientes",
    ]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetClientes",
      "ActionSetNavieras",
      "ActionSetTipoContratos",
      "ActionSetContenedores",
      "ActionSetCommodity",
      "ActionSetContratos",
      "ActionSetEstadoAcuerdoLinea",
      "ActionSetPol",
      "ActionSetPod",
      "ActionSetShowAcuerdoClientes"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosClientes",
      "actionSetDataListaNavierasNoUCC"
    ]),

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async getListaAcuerdosClientes() {

      this.load = true;

      this.ActionSetLoading(true);

      this.ActionSetShowAcuerdoClientes(false);

      const {
        data_table,
        filtros_clientes,
        filtros_contenedor,
        filtros_contratos,
        filtros_navieras,
        filtros_navieras_no_ucc,
        filtros_pod,
        filtros_pol,
        filtros_productos
      } = await getAcuerdosClientes();

      await this.actionSetDataListarTarifasAcuerdosClientes(data_table);

      this.ActionSetClientes(filtros_clientes);
      this.ActionSetNavieras(filtros_navieras);
      this.actionSetDataListaNavierasNoUCC(filtros_navieras_no_ucc);
      this.ActionSetContenedores(filtros_contenedor);
      this.ActionSetCommodity(filtros_productos);
      this.ActionSetContratos(filtros_contratos);
      this.ActionSetPol(filtros_pol);
      this.ActionSetPod(filtros_pod);

      this.load = false;

      this.ActionSetLoading(false);
    },
  },
  created() {
    this.getListaAcuerdosClientes();
    this.actualizarURL();
  },
  watch: {
    dataDatatableTarifasAcuerdosClientes: function (_new) {
      if (_new) this.data = _new;
    },
  },
};
</script>
<style></style>
